export const attribuitions = [
  { label: "CLIENTE", value: "CLIENTE" },
  { label: "DUPONT", value: "DUPONT" },
];
